<template>

<div v-bind:style="styles.selectButton">
  <button v-bind:style="styles.buttonReportCustom"
          v-on:click="show_hide()">
        {{title}}
  </button>
  <div ref="button_1"
      v-if="show"
      v-on-clickaway="away"
      :style="style">
    <div id="tableDesc">
      <button id="buttonSelect" v-on:click="includeAll()">Выбрать все</button>
      <button id="buttonSelect" v-on:click="dropAll()">Снять все</button>
      <h3 v-if="false" id="cross" v-on:click="show_hide()">✖</h3>
    </div>
    <div id="tableContainer">
      <table id="choiceTable">
        <template v-for="(row, i) in nestedregs">
          <tr id="mainRows"  :class="{ opened: opened.includes(row.id) }">
            <td @click="toggle(row.id)">{{ i+1 }}</td>
            <td>{{ row.name }}</td>
            <td @click="addReg(row.id)" v-bind:style="{background: '#4caf50'}" v-if="added.includes(row.id)">{{ '-' }}</td>
            <td @click="addReg(row.id)" v-else>{{'+'}}</td>
          </tr>
          <tr id="subRows" v-for="(subrow, j) in row.sub_regions" v-if="opened.includes(row.id)">
            <td>{{ i+1  +'.'+ (j+1)}}</td>
            <td>{{subrow}}</td>
            <td @click="addReg(subrow)" v-bind:style="{background: '#4caf50'}" v-if="added.includes(subrow)">{{ '-' }}</td>
            <td @click="addReg(subrow)" v-else>{{'+'}}</td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</div>    
</template>

<script>

import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'nestedSelect',
  props: ['title', 'nestedregs', 'top', 'left', 'height', 'selected'],
  mixins: [ clickaway ],
  watch: { 
    nestedregs: function(newVal, oldVal) {
      console.log(newVal, oldVal)
      if (typeof this.nestedregs !== 'undefined') {
        this.added = []
        Array.prototype.forEach.call(this.nestedregs ,element => {
          const index = this.added.indexOf(element.id)
          if (index < 0) this.added.push(element.id)
        })
        this.$emit('update:selected', this.added)
      }
    }
  },
  computed: {
    style () {
      return {
          position: 'fixed',
          zIndex: '120',
          backgroundColor: 'white',
          boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
          width: '300px',
          height: '400px',
          top: this.top,
          left: this.left,
          padding: '0px 10px 0px 10px'
        }
    }
  },
  mounted() {
    if (typeof this.nestedregs !== 'undefined') {
      Array.prototype.forEach.call(this.nestedregs ,element => {
        const index = this.added.indexOf(element.id)
        if (index < 0) this.added.push(element.id)
      }) 
      this.$emit('update:selected', this.added)
    }
  },
  data: function() {
    return {
      added: [],
      opened: [],
      interval: '',
      show: false,
      styles: {
        buttonReportCustom: {
          width: '80px',
          height: '30px',
          margin: '0',
          borderWidth: '1px',
          outline: 'none',
          borderRadius: '8px',
          fontSize: '12px',
          backgroundColor: '#f5f5f5',
          cursor: 'pointer',
        },
        selectParameter: {
          position: 'relative',
          zIndex: '100',
          backgroundColor: 'white',
          boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
          width: '300px',
          height: '600px',
          top: '21%',
          left: '2%',
          padding: '0px 10px 0px 10px'
        },
        selectButton: {
          width: '100px',
          height: '30px',
          position: 'relative',
          borderRadius: '8px'
        }
        
      }
    }
  },
  methods: {
    away: function() {
      console.log('clicked away');
      this.show_hide()
    },
    handleChanges() {
      this.$forceUpdate()
    },
    toggle(id) {
      const index = this.opened.indexOf(id);

      this.$emit('update:selected', this.added)

      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },
    show_hide() {
      if(this.show) {
        this.styles.buttonReportCustom.backgroundColor = '#f5f5f5'
        this.styles.buttonReportCustom.color = 'black'
      } else {
        this.styles.buttonReportCustom.backgroundColor = ' #4d82cb'
        this.styles.buttonReportCustom.color = 'white'
      }
      this.show = !this.show
    },
    includeAll() {
      this.nestedregs.forEach(element => {
        const index = this.added.indexOf(element.id)
        if (index < 0) this.added.push(element.id)
      })
      this.$emit('update:selected', this.added)
    },
    dropAll() {
      this.nestedregs.forEach(element => {
        const index = this.added.indexOf(element.id)
        this.added.splice(index, 1)
      })
      this.$emit('update:selected', this.added)
    },
    addReg(name) {
      console.log(name)
      const index = this.added.indexOf(name)

      if (index > -1) {
        this.added.splice(index, 1)
      } else {
        this.added.push(name)
      }

      this.$emit('update:selected', this.added)
    },
  },
  created() {
    this.interval = setInterval(() => this.handleChanges(), 1000);
  },
}

</script>

<style>

#tableDesc {
  background-color: white;
  text-align: center;
}

#tableParag {
  margin: 12px 0px 15px 0px;
  font-size: 17px;
  font-weight: bold;
}

#buttonSelect {
  width: 50%;
  height: 25px;
  margin: 12px 20px 10px 10px;

  border-width: 0;
  outline: none;
  border-radius: 2px;

  font-size: 11px;
  font-weight: bold;
  color: white;

  background-color: #9e9e9e;

  cursor: pointer;
}

#tableContainer {
  position: relative;
  border-style: solid;
  border-width: 1px;

  margin-bottom: 0px;
  height: 334px;
}

#choiceTable {
  width: 100%;
}

#choiceTable td:nth-child(1)  {
  background-color: #4d82cb;
  color: white;
  width: 25px;
  cursor: pointer;
  text-align: center;
}

#choiceTable td:nth-child(2)  {
  width: 195px;
}

#choiceTable td:nth-child(3)  {
  text-align: center;
  cursor: pointer;
}

#subRows td:nth-child(2)  {
  background-color: #f5f5f5;
}

#subRows td:nth-child(3)  {
  background-color: #f5f5f5;
}

h3#cross {
  text-align: center;
  font-size: 20px;
  margin: 12px 12px 0px 10px;
  cursor: pointer;
}  

#tableContainer::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#tableContainer::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#tableContainer::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

#tableDesc::-webkit-scrollbar{
    width: 0;
    border-radius: 0;
    background: transparent;
    display: none;
  }

/* Track */
#tableDesc::-webkit-scrollbar-track {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}

/* Handle */
#tableDesc::-webkit-scrollbar-thumb {
  width: 0;
  border-radius: 0;
  height: 0;
  background: transparent;
  display: none;
}
</style>